/**
 * @module app.pm
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { PopulationManagementModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(PopulationManagementModule.registrationKey, PopulationManagementModule);

    config.globalResources([
        // elements

        // elements/members

        // elements/providers

        // value-converters
    ]);
}
